import RecurveBaseComponent from '../RecurveBaseComponent';
import React, { Component } from 'react';
//DELETE THIS WHEN MOVING OFF OF SHIMS
import Utility from '../../functions/utility';
const SpecialsContext = React.createContext( {

});
class Specials extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            hasPopupError: false,
            hasServerError: false,
            loading: true,
            specialName: window.session.specialNamePlural,
            specialBannerUrl: window.session.specialBannerUrl,
            specialNavs: []
        };
    }

    componentDidMount() {
        Utility.initiateGetRequest(`menu/specials/api`, this).then( (response) => {
            response.json().then( (resJSON) => {
                this.setState({specialNavs: resJSON, loading: false});
            }, (jsonParseFailure) => {
                console.log(jsonParseFailure);
            })
        }, (rejection) => {
            console.log(rejection);
        });
    }

    render() {
        let wizardContent = this.props.content;
        return (
        <SpecialsContext.Provider value={this.state}>
            <RecurveBaseComponent loading={this.state.loading} error={this.state.error} hasServerError={this.state.hasServerError} hasPopupError={this.state.hasPopupError} content={wizardContent}/>
        </SpecialsContext.Provider>)
    }
}
export {Specials, SpecialsContext};